import type { DeclarationsSummary, SummaryAnnual, SummaryCell } from './types';

export const knowsPending = (summary: DeclarationsSummary) => !summary.loading && summary.reliable;

export const hasPendingMonths = (summary: DeclarationsSummary) =>
	summary.months.some((month) => month.cells.some((cell) => cell.pending));

export const assumesPendingMonths = (summary: DeclarationsSummary) => !knowsPending(summary) || hasPendingMonths(summary);

export const annualOf = (summary: DeclarationsSummary, year: number): SummaryAnnual | undefined =>
	summary.annuals.find((annual) => annual.year === year);

export const annualOwed = (summary: DeclarationsSummary, year: number) => {
	const annual = annualOf(summary, year);
	return Boolean(annual?.obligated && !annual.settled);
};

export const cellsOf = (summary: DeclarationsSummary): (SummaryCell & { year: number; month: number })[] =>
	summary.months.flatMap((month) => month.cells.map((cell) => ({ ...cell, year: month.year, month: month.month })));
